/* file description */
import React from 'react';
import LinkRender from './../component/RecordSelectLinkShowModal/linkRender';
import { COLUMN_FROM, VALUE_TYPES } from './consts';
import { TransformNalmalType2TableColumn } from './type';
import { Api as FetchAPI } from '@/utils';

export const transformLinkShowRecord2Column: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
  // store,
  // ...others
}) => {
  const { name, label, linkBy, linkByFieldName, linkByLabel } = field;
  targetColumn.dataIndex = `${linkBy}_LINK_${name}`;
  targetColumn.valueType = VALUE_TYPES.TEXT;
  targetColumn.align = 'center';
  targetColumn.sorter = false;

  // if (isOpenGroup) {
  //   targetColumn.dependencies = [linkBy];
  // }

  // 不可修改处理 - 联动显示字段统统不可修改
  // targetColumn.editable = false;
  targetColumn.fieldProps = () => {
    const baseProps = {
      disabled: true,
      placeholder: `填充 ${linkByLabel} 之后，${label} 将自动关联展示`,
    };
    return baseProps;
  };

  targetColumn.render = (dom, entity) => {
    let targerValue = entity.value;
    if (entity.from === COLUMN_FROM.FORM) {
      targerValue = entity?.formValue?.[linkBy];
    }
    if (entity.from === COLUMN_FROM.TABLE) {
      targerValue = entity.formValue?.[entity.rowIndex]?.[linkBy];
    }
    const { setViewValue } = entity;
    return <LinkRender store={entity.storeValue} field={field} API={{ FetchAPI }} rowsData={entity.formValue} columnFrom={entity.from} targerValue={targerValue} setViewValue={setViewValue} />;
  };

  return targetColumn;
};
